import {AppState, AssignedClinic, WorkforceClinicPortal} from "../../AppState";

//do not export this unless there is no other choice, i.e. its easy to add a new selector..the AssignedClinic has some bad constructs we don't want to propagate
//we also likely would be better off adding an interface(/generic..) in a new file to reduce the looping, but memoization should make that a bad idea..
export function GetSelectedAssignedClinic(state?: AppState): AssignedClinic | null{
    if(!state){
        return null;
    }
    const companyIdToSearchFor = state?.Workforce1State.selectedCompany;
    if(!companyIdToSearchFor){
        return null;
    }
    let clinicFound: AssignedClinic | null = null;
    for (const portal of state?.Workforce1Companies.visibleCompanies) {
        for(const clinic of  portal.AssignedClientDetailsOfClinic){
            if(clinic.ParticipationID == companyIdToSearchFor){
                clinicFound = clinic;
            }
        }
        if(clinicFound){
            break;
        }
    }
    return clinicFound;
}

export function GetSelectedPortal(state?: AppState): WorkforceClinicPortal | undefined {
  // Matching as strings because both Workforce1State.selectedCompany and ParticipationID can either be number or string in different situations
  const companyIdToSearchFor = `${state?.Workforce1State.selectedCompany}`
  return companyIdToSearchFor ? state?.Workforce1Companies.visibleCompanies.find(item => `${item.ParticipationID}` === companyIdToSearchFor) : undefined
}

const noUserNameFound: string = "company-to-username-mapping-error@crlcorp.com";
export function getUserNameForSelectedCompany(state?: AppState): string{
    const clinicPicked = GetSelectedAssignedClinic(state);
    return clinicPicked?.UserName || noUserNameFound;
}
export function EmailOfUserForSelectedCompany(state?: AppState): string{
    return getUserNameForSelectedCompany(state);
}
const noRole: number = -1;
export function RoleIdForSelectedCompany(state?: AppState): number{
    const clinicPicked = GetSelectedAssignedClinic(state);
    return clinicPicked?.RoleID || noRole;
}
const noCompanyName = 'Unnamed Company'
export function SelectedCompanyName(state?: AppState): string{
    const clinicPicked = GetSelectedAssignedClinic(state);
    return clinicPicked?.Name || noCompanyName;
}

export function SelectedAccountName(assignedClinic?: AssignedClinic | null) {
  if (!assignedClinic) {
    return undefined
  }

  if (assignedClinic.LocationID || 0 > 0) {
    return `${assignedClinic.Name} / ${assignedClinic.LocationName}`
  }

  return assignedClinic.Name
}

export function CompareAccounts(a: AssignedClinic, b: AssignedClinic) {
  return (a.Name).localeCompare(b.Name) || (a.LocationName || "").localeCompare(b.LocationName || "")
}

export function SelectedPortalName(state?: AppState): string | undefined {
    return GetSelectedPortal(state)?.ImplementationName
}
export function getLoggedInUserName(state?: AppState): string  {
    let userName = getUserNameForSelectedCompany(state)
    if(userName === noUserNameFound){
        userName = `${state?.Workforce1State.userName}`
    }
    return userName || noUserNameFound
}

export function isInPortal(state?: AppState): boolean {
    let userName = getUserNameForSelectedCompany(state)
    if (userName === noUserNameFound) {
        userName = `${state?.Workforce1State.userName}`
        if (userName) {
            return true
        }
    }
    return false
}
